import React, { useEffect, useState } from "react";
import { IDividerPart, IDividerSettings } from "ts/components/course-author/types";
import { CourseInstructionPartOperations } from "../CourseInstructionPart.types";
import {
  Divider,
  DividerColorFieldSet,
  DividerFormSelect,
  DividerInput,
  FlexFormContainer,
  SelectorFieldSet,
} from "./DividerPart.styles";
import { SeparatorFieldSet, ColourInput, PreviewBoxContainer, SeparatorErrorMessage } from "./SpacerPart.styles";

interface IDividerPartProps {
  dividerPart: IDividerPart;
  edit: boolean;
  partOperations: CourseInstructionPartOperations;
}

export const DividerPart: React.FC<IDividerPartProps> = props => {
  const { dividerPart, partOperations, edit } = props;
  const [settings, setSettings] = useState<IDividerSettings["settings"]>(dividerPart.content.settings);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const onDividerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "") {
      setErrorMessage("Please fill in all fields");
      return;
    } else if (Number(e.target.value) < 0) {
      setErrorMessage("Values cannot be negative");
      return;
    }

    setErrorMessage("");

    if (["marginTop", "marginBottom", "thickness"].includes(e.target.name)) {
      setSettings({ ...settings, [e.target.name.replace("divider", "")]: Number(e.target.value) });
    } else {
      setSettings({ ...settings, color: e.target.value });
    }
  };

  const onStyleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSettings({
      ...settings,
      style: e.target.value as IDividerSettings["settings"]["style"],
    });
  };

  useEffect(() => {
    partOperations.editDivider({ settings });
  }, [settings]);

  return edit ? (
    <>
      <SeparatorErrorMessage>{errorMessage}</SeparatorErrorMessage>
      <FlexFormContainer data-testid="divider">
        <SelectorFieldSet data-testid="style">
          <legend>Type</legend>
          <DividerFormSelect name="style" id="style" value={settings.style} onChange={onStyleChange}>
            <option value="solid">Line</option>
            <option value="dotted">Dots</option>
            <option value="dashed">Dashes</option>
          </DividerFormSelect>
        </SelectorFieldSet>

        <SeparatorFieldSet data-testid="thickness">
          <legend>Thickness</legend>
          <DividerInput
            name="thickness"
            placeholder="Enter Amount"
            type="number"
            defaultValue={String(settings.thickness)}
            onBlur={onDividerChange}
          />
        </SeparatorFieldSet>
        <SeparatorFieldSet data-testid="marginTop">
          <legend>Margin Top</legend>
          <DividerInput
            name="marginTop"
            placeholder="Enter Amount"
            type="number"
            defaultValue={String(settings.marginTop)}
            onBlur={onDividerChange}
          />
        </SeparatorFieldSet>
        <SeparatorFieldSet data-testid="marginBottom">
          <legend>Margin Bottom</legend>
          <DividerInput
            name="marginBottom"
            placeholder="Enter Amount"
            type="number"
            defaultValue={String(settings.marginBottom)}
            onBlur={onDividerChange}
          />
        </SeparatorFieldSet>
        <DividerColorFieldSet data-testid="color">
          <legend>Colour</legend>
          <ColourInput
            name="colour"
            placeholder="Colour"
            type="color"
            defaultValue={settings.color}
            onChange={onDividerChange}
          />
        </DividerColorFieldSet>
      </FlexFormContainer>
    </>
  ) : (
    <PreviewBoxContainer>
      <Divider
        color={settings.color}
        marginBottom={settings.marginBottom}
        marginTop={settings.marginTop}
        dividerStyle={settings.style}
        thickness={settings.thickness}
      />
    </PreviewBoxContainer>
  );
};
